import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { GraphQLProvider } from '@/libs/graphql-provider'
import OrgBootstrapper from '@/context/org-bootstrapper'
import { Toaster } from '@/components/ui/toaster'
import GeneralError from '@/features/errors/general-error'
import NotFoundError from '@/features/errors/not-found-error'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => {
    return (
      <GraphQLProvider>
        <OrgBootstrapper />
        <Outlet />
        <Toaster />
      </GraphQLProvider>
    )
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
